import { securedApiCall } from '../Shared/SharedServices';
import helper from '../Shared/helper'

const proxyRootURL = helper.getProxyRootURL();

export default {
    async getDashboardAdmins() {
        const url = 'GetAllAdmins';
        const requestOptions = {
            method: 'GET'
        }
        return await securedApiCall(proxyRootURL + url, requestOptions);
    },
    async createDashboardAdmin(admin) {
        const url = 'AddAdmin';
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(admin)
        }
        return await securedApiCall(proxyRootURL + url, requestOptions);
    },
    async deleteDashboardAdmin(id) {
        const url = 'DeleteAdmin';
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(id)
        }
        return await securedApiCall(proxyRootURL + url, requestOptions);
    },
    async updateDashboardAdmin(admin) {
        const url = 'UpdateAdmin';
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(admin)
        }
        return await securedApiCall(proxyRootURL + url, requestOptions);
    },
    async syncUser(oSUidmId, personID) {
        const url = `syncuser?oSUidmId=${oSUidmId}&personId=${personID}`
        const requestOptions = {
            method: 'GET'
        }
        return await securedApiCall(proxyRootURL + url, requestOptions);
    },
    async GetOCIORecordByOsuIdmId(osuIdmId) {
        const url = 'ocio/osuIdmId=' + osuIdmId
        const requestOptions = {
            method: 'GET'
        }
        return await securedApiCall(proxyRootURL + url, requestOptions);
    },
    async GetOCIORecordByWorkForceID(workForceID) {
        console.log(workForceID)
        const url = 'ocio/wfid=' + workForceID
        const requestOptions = {
            method: 'GET'
        }
        return await securedApiCall(proxyRootURL + url, requestOptions);
    },
    async GetOCIORecordByPersonID(personID) {
        const url = 'ocio/personId=' + personID
        const requestOptions = {
            method: 'GET'
        }
        return await securedApiCall(proxyRootURL + url, requestOptions);
    },
    async GetMatrixUserByPersonID(personID) {
        const url = 'matrix/personId=' + personID
        const requestOptions = {
            method: 'GET'
        }
        return await securedApiCall(proxyRootURL + url, requestOptions);
    },
    async GetMatrixUserByWorkForceID(workForceID) {
        const url = 'matrix/wfid=' + workForceID
        const requestOptions = {
            method: 'GET'
        }
        return await securedApiCall(proxyRootURL + url, requestOptions);
    },
    async GetMatrixUserByCredNumber(credNumber) {
        const url = 'matrix/credNumber=' + credNumber
        const requestOptions = {
            method: 'GET'
        }
        return await securedApiCall(proxyRootURL + url, requestOptions);
    },
    async getAutoCompleteData() {
        const url = 'GetAutoCompleteData'
        const requestOptions = {
            method: 'GET'
        }
        return await securedApiCall(proxyRootURL + url, requestOptions);
    },
    async RefreshAutoCompleteData() {
        const url = 'RefreshAutocompleteCaches'
        const requestOptions = {
            method: 'GET'
        }
        return await securedApiCall(proxyRootURL + url, requestOptions);
    },
    async getXrefData() {
        const url = 'Xref/GetXrefData'
        const requestOptions = {
            method: 'GET'
        }
        return await securedApiCall(url, requestOptions);
    },
    async addXrefData(xref) {
        const url = 'Xref/AddXref'
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(xref)
        }
        return await securedApiCall(url, requestOptions);
    },
    async updateXrefData(xref) {
        const url = 'Xref/UpdateXref'
        const requestOptions = {
            method: 'PUT',
            body: JSON.stringify(xref)
        }
        return await securedApiCall(url, requestOptions);
    },
    async deleteXrefData(xref) {
        const url = 'Xref/DeleteXref'
        const requestOptions = {
            method: 'DELETE',
            body: JSON.stringify(xref)
        }
        return await securedApiCall(url, requestOptions);
    },
    async GetUpdateHistories() {
        const url = `Report/UpdateHistory`
        const requestOptions = {
            method: 'GET'
        }
        return await securedApiCall(url, requestOptions);
    },
    async GetUpdateHistory(jobID) {
        const url = `Report/UpdateHistory/id=${jobID}`
        const requestOptions = {
            method: 'GET'
        }
        return await securedApiCall(url, requestOptions);
    },
    async GetUserHistory(osuIdmID) {
        const url = `Report/UpdateHistory/oSUIdmID=${osuIdmID}`
        const requestOptions = {
            method: 'GET'
        }
        return await securedApiCall(url, requestOptions);
    },
    async GetRecentJobSummary() {
        const url = 'Report/RecentJobSummary'
        const requestOptions = {
            method: 'GET'
        }
        return await securedApiCall(url, requestOptions);
    },
    async GetJobSummaries() {
        const url = 'Report/JobSummaries'
        const requestOptions = {
            method: 'GET'
        }
        return await securedApiCall(url, requestOptions);
    },
    async GetStagingTable() {
        const url = 'Report/StagingTable'
        const requestOptions = {
            method: 'GET'
        }
        return await securedApiCall(url, requestOptions);
    },
    async GetStagingTableAdmin() {
        const url = 'Report/StagingTableAdmin'
        const requestOptions = {
            method: 'GET'
        }
        return await securedApiCall(url, requestOptions);
    },
    async AddToStagingTable(osuIdmid) {
        const url = 'Report/AddToStagingTable/id=' + osuIdmid
        const requestOptions = {
            method: 'GET'
        }
        return await securedApiCall(url, requestOptions);
    },
    async RemoveFromStagingTable(osuIdmid) {
        const url = 'Report/RemoveFromStagingTable/id=' + osuIdmid
        const requestOptions = {
            method: 'GET'
        }
        return await securedApiCall(url, requestOptions);
    },
    async GetActiveMatrixRecords() {
        const url = 'ActiveMatrixRecords'
        const requestOptions = {
            method: 'GET'
        }
        return await securedApiCall(proxyRootURL + url, requestOptions);
    },
    async GetInactiveMatrixRecords() {
        const url = 'InactiveMatrixRecords'
        const requestOptions = {
            method: 'GET'
        }
        return await securedApiCall(proxyRootURL + url, requestOptions);
    },
    async GetOverride() {
        const url = 'Sync/GetOverride';
        const requestOptions = {
            method: 'GET'
        }
        return await securedApiCall(proxyRootURL + url, requestOptions);
    },
    async TogleSyncOverride() {
        const url = 'ToggleSyncOverride';
        const requestOptions = {
            method: 'Post',
            body: null
        }
        return await securedApiCall(proxyRootURL + url, requestOptions);
    }  ,
    async GetErrors() {
        const url = `Report/ErrorQueue`
        const requestOptions = {
            method: 'GET'
        }
        return await securedApiCall(url, requestOptions);
    }
};